import { useEffect, useState } from "react";

import arrow from "../../../assets/img/common/arrow.svg";
import tickStandard from "../../../assets/img/common/tick-elite.svg";
import tickSolo from "../../../assets/img/common/tick-standard.svg";
import BackButtonComponent from "../../../components/BackButtonComponent/BackButtonComponent";
import ComponentCircleLoader from "../../../components/Loaders/ComponentCircleLoader";
import {
  ArrowLeft,
  ComparePlansLink,
  EverythingInPrev,
  FeatureText,
  FeatureTickIcon,
  HeaderTitle,
  MoneyBackTag,
  NotificationText,
  PlanDescription,
  PlanFeaturesContainer,
  PlanName,
  PlanNameAndTagContainer,
  PlanNameTag,
  PlanPrice,
  PlanPriceContainer,
  PlanPriceText,
  PlanSelectButton,
  PlusAddonDiv,
  PricingPlanContainer,
  PricingPlanHeader,
  SinglePlanFeature,
  SinglePricingCard,
  TopSectionContainer,
  TypeText,
  TypeTogglerContainer,
} from "../../../components/PricingPlan/pricingPlanStyles";
import {
  PricingCardContainer,
  PricingMainContainer,
  SeeFullComparisonButton,
  SeeFullComparisonDiv,
  TickImage,
  ToggleSection,
  ToggleText,
} from "../../../styledComponents/billing";
import {
  CardTitle,
  CommonFlex,
  CommonGrid,
  CommonText,
  PageTitle,
} from "../../../styledComponents/common";
import {
  ToggleButton,
  ToggleButtonRound,
} from "../../../styledComponents/invoice";
import {
  CurrentPlanBadgeText,
  CurrentPlanDot,
  SubscriptionCurrentPlanBadge,
  YearlySaveBadge,
} from "../subscriptionStyles";
import DowngradeModal from "./DowngradeModal";
import { PricingAccordion } from "./PricingAccordion";
import SoloErrorModal from "./SoloErrorModal";
import { planFeatures } from "./pricingPlanData";

const getIsCurrent = (
  planId,
  planStatus,
  planInterval,
  yearlyId,
  monthlyId,
) => {
  if (!planId || !planStatus) return false;
  if (planStatus === "active" || planStatus === "trialing") {
    if (planInterval === "yearly") {
      return planId === yearlyId;
    } else {
      return planId === monthlyId;
    }
  }
  return false;
};

const CurrentPlanBadge = props => {
  return (
    <SubscriptionCurrentPlanBadge isCurrent={props.isCurrent} plan={props.plan}>
      <CurrentPlanDot plan={props.plan} />
      <CurrentPlanBadgeText>Current Plan</CurrentPlanBadgeText>
    </SubscriptionCurrentPlanBadge>
  );
};

const ChangeSubscription = props => {
  const [planInterval, setPlanInterval] = useState("yearly");
  const [currentPlanId, setCurrentPlanId] = useState(null);
  const [currentPlanName, setCurrentPlanName] = useState("");
  const [currentPlanInterval, setCurrentPlanInterval] = useState(null);
  const [currentPlanStatus, setCurrentPlanStatus] = useState(null);
  const [isPaddleSubscriptionActive, setIsPaddleSubscriptionActive] =
    useState(false);
  const [isDowngrading, setIsDowngrading] = useState(false);
  const [soloError, setSoloError] = useState(false);

  const {
    getOrganizationPlans,
    subscriptionPlans,
    currentSubscription,
    getOrganizationSubscription,
    selectedOrganization,
    clearCurrentSubscription,
  } = props;

  const planPriceMonthly = {
    standard: 15,
    elite: 20,
  };
  const planPriceYearly = {
    standard: 9,
    elite: 12,
  };

  useEffect(() => {
    getOrganizationPlans();
    return () => {
      clearCurrentSubscription();
      setCurrentPlanId(null);
      setCurrentPlanName("");
      setCurrentPlanInterval(null);
      setCurrentPlanStatus(null);
      setIsPaddleSubscriptionActive(false);
      setPlanInterval("yearly");
    };
  }, []);

  const [standardFree, setStandardFree] = useState({
    id: "",
    name: "standard-free",
    paddleId: null,
    amount: null,
  });

  const [eliteFree, setEliteFree] = useState({
    id: "",
    name: "elite-free",
    paddleId: null,
    amount: null,
  });

  const [standardYearly, setStandardYearly] = useState({
    id: "",
    name: "standard-yearly",
    paddleId: null,
    amount: null,
  });
  const [eliteYearly, setEliteYearly] = useState({
    id: "",
    name: "elite-yearly",
    paddleId: null,
    amount: null,
  });
  const [standardMonthly, setStandardMonthly] = useState({
    id: "",
    name: "standard-monthly",
    paddleId: null,
    amount: null,
  });
  const [eliteMonthly, setEliteMonthly] = useState({
    id: "",
    name: "elite-monthly",
    paddleId: null,
    amount: null,
  });

  useEffect(() => {
    if (subscriptionPlans && subscriptionPlans.length > 0) {
      subscriptionPlans.map(item => {
        if (item.nick_name === "standard-free") {
          setStandardFree({
            id: item.id,
            name: item.name,
            paddleId: item.paddle_id,
            amount: item.amount,
          });
        } else if (item.nick_name === "elite-free") {
          setEliteFree({
            id: item.id,
            name: item.name,
            paddleId: item.paddle_id,
            amount: item.amount,
          });
        } else if (item.name === "Standard" && item.interval === "yearly") {
          setStandardYearly({
            id: item.id,
            name: item.name,
            paddleId: item.paddle_id,
            amount: item.amount,
          });
        } else if (item.name === "Elite" && item.interval === "yearly") {
          setEliteYearly({
            id: item.id,
            name: item.name,
            paddleId: item.paddle_id,
            amount: item.amount,
          });
        } else if (item.name === "Standard" && item.interval === "monthly") {
          setStandardMonthly({
            id: item.id,
            name: item.name,
            paddleId: item.paddle_id,
            amount: item.amount,
          });
        } else if (item.name === "Elite" && item.interval === "monthly") {
          setEliteMonthly({
            id: item.id,
            name: item.name,
            paddleId: item.paddle_id,
            amount: item.amount,
          });
        }
      });
    }
  }, [subscriptionPlans]);

  useEffect(() => {
    if (selectedOrganization && selectedOrganization.id) {
      if (
        !currentSubscription ||
        (currentSubscription.organization &&
          currentSubscription.organization !== selectedOrganization.id)
      ) {
        const payload = {
          organization_id: selectedOrganization.id,
        };
        getOrganizationSubscription(payload);
      }
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (currentSubscription && currentSubscription.plan) {
      setCurrentPlanId(currentSubscription.plan.id);
      setCurrentPlanName(currentSubscription.plan.name);
      setCurrentPlanInterval(currentSubscription.plan.interval);
      if (currentSubscription.plan.name !== "Free") {
        setPlanInterval(currentSubscription.plan.interval);
      }
      setCurrentPlanStatus(currentSubscription.status);
      setIsPaddleSubscriptionActive(
        currentSubscription.paddlesubscription_active,
      );

      // This part is for testing purpose
      // setIsPaddleSubscriptionActive(true);
      // setCurrentPlanStatus("active");
      // setCurrentPlanInterval("monthly");
    }
  }, [currentSubscription]);

  const changeToFree = plan => {
    // console.log(plan.nick_name);
    setIsDowngrading(true);
    // props.history.push({
    //   pathname: '/user/checkout',
    //   state: {
    //     plan: {
    //       id: plan.id,
    //       name: plan.name,
    //       paddleId: plan.paddleId,
    //       amount: plan.amount,
    //       interval: planInterval,
    //       currentUsers: currentSubscription?.member_count,
    //     },
    //   },
    // });
  };

  const confirmSelectPlan = plans => {
    let plan = {};
    if (plans.monthly === null) {
      plan = plans.yearly;
    } else {
      plan = plans[planInterval];
    }
    if (
      currentPlanId !== plan.id ||
      (currentPlanStatus === "trialing" && plan.name !== "Free")
    ) {
      if (currentPlanName === "Free" && plan.name === "Free") {
        if (
          currentSubscription &&
          currentSubscription.member_count &&
          currentSubscription.member_count > 100
        ) {
          setSoloError(true);
        } else {
          changeToFree(plan);
        }
      } else {
        props.history.push({
          pathname: "/user/checkout",
          state: {
            interval: planInterval,
            yearly: {
              id: plans.yearly.id,
              name: plans.yearly.name,
              paddleId: plans.yearly.paddleId,
              amount: plans.yearly.amount,
              interval: "yearly",
              currentUsers: currentSubscription?.member_count,
            },
            monthly: {
              id: plans.monthly.id,
              name: plans.monthly.name,
              paddleId: plans.monthly.paddleId,
              amount: plans.monthly.amount,
              interval: "monthly",
              currentUsers: currentSubscription?.member_count,
            },
            currentPlan: {
              id: currentPlanId,
              name: currentPlanName,
              interval: currentPlanInterval,
              status: currentPlanStatus,
            },
          },
        });
      }
    }
  };

  return (
    <div className="content">
      <DowngradeModal
        isOpen={isDowngrading}
        toggle={() => setIsDowngrading(false)}
      />
      <SoloErrorModal isOpen={soloError} toggle={() => setSoloError(false)} />
      <PageTitle marginBottom="30px">Billing - Subscription Plan</PageTitle>
      <BackButtonComponent
        onClick={() => props.history.push("/user/settings")}
        subTitle="Back to settings"
      />
      <PricingMainContainer>
        {props.isLoading ? (
          <ComponentCircleLoader />
        ) : (
          <>
            <div>
              <CommonGrid alignItem="flex-start" columns="auto auto auto">
                <CardTitle margin="0 0 0 10px">Choose Plan</CardTitle>
                <CommonGrid columns="auto" gap="10px">
                  <ToggleSection>
                    <ToggleText
                      active={planInterval === "yearly"}
                      onClick={() => setPlanInterval("yearly")}
                    >
                      <YearlySaveBadge isActive={planInterval === "yearly"}>
                        Save 40%
                      </YearlySaveBadge>
                      Yearly
                    </ToggleText>
                    <ToggleText
                      active={planInterval === "monthly"}
                      onClick={() => setPlanInterval("monthly")}
                    >
                      Monthly
                    </ToggleText>
                  </ToggleSection>
                </CommonGrid>
                <MoneyBackTag>
                  {" "}
                  <span>✅</span> 100% money back guarantee
                </MoneyBackTag>
              </CommonGrid>
              {currentSubscription?.plan?.name === "Free" && (
                <CommonFlex justifyContent="space-around" margin="0 0 40px 0">
                  <CommonFlex
                    direction="column"
                    gap="3px"
                    style={{ justifyItems: "center" }}
                  >
                    <CardTitle>Paid Plans</CardTitle>
                    <CommonText fontSize="12px">
                      Unlock full potential
                    </CommonText>
                  </CommonFlex>

                  <CommonFlex
                    direction="column"
                    gap="3px"
                    style={{ justifyItems: "center" }}
                  >
                    <CardTitle>Free Plans</CardTitle>
                    <CommonText fontSize="12px">
                      Get started at no cost
                    </CommonText>
                  </CommonFlex>
                </CommonFlex>
              )}
              <PricingCardContainer
                isFree={currentSubscription?.plan?.name === "Free"}
                isYearly={
                  currentPlanInterval &&
                  currentPlanInterval === "yearly" &&
                  currentPlanStatus &&
                  currentPlanStatus === "active"
                }
              >
                <SinglePricingCard plan="standard">
                  <CurrentPlanBadge
                    isCurrent={
                      currentPlanInterval === planInterval &&
                      currentPlanName === "Standard"
                    }
                    plan="Standard"
                  />

                  <div>
                    <PlanNameAndTagContainer>
                      <PlanName plan="standard">STANDARD</PlanName>
                      <PlanNameTag plan="standard">Site Management</PlanNameTag>
                    </PlanNameAndTagContainer>
                    <PlanPriceContainer>
                      <PlanPrice>
                        $
                        {planInterval === "yearly"
                          ? planPriceYearly.standard
                          : planPriceMonthly.standard}
                      </PlanPrice>
                      <PlanPriceText>per user/month</PlanPriceText>
                    </PlanPriceContainer>
                    <PlanDescription plan="standard">
                      Best for Managing Operations
                    </PlanDescription>
                  </div>
                  <PlanFeaturesContainer>
                    {planFeatures.standard.map((item, index) => (
                      <SinglePlanFeature key={index}>
                        <TickImage
                          src={tickStandard}
                          alt=""
                          style={{ margin: `2px 0 0 0` }}
                        />
                        <FeatureText>{item}</FeatureText>
                      </SinglePlanFeature>
                    ))}
                  </PlanFeaturesContainer>
                  <PlanSelectButton
                    plan="standard"
                    style={{ marginTop: `auto` }}
                    isCurrent={
                      currentPlanName === "Standard" &&
                      currentPlanInterval === planInterval &&
                      currentPlanStatus === "active"
                    }
                    onClick={() =>
                      confirmSelectPlan({
                        yearly: standardYearly,
                        monthly: standardMonthly,
                      })
                    }
                  >
                    {currentPlanName === "Standard" &&
                    currentPlanInterval === planInterval &&
                    currentPlanStatus === "trialing"
                      ? "Continue Current Plan"
                      : currentPlanName === "Free"
                      ? "Upgrade to STANDARD"
                      : "Get Started"}
                  </PlanSelectButton>
                </SinglePricingCard>
                <SinglePricingCard plan="elite">
                  <CurrentPlanBadge
                    isCurrent={
                      currentPlanInterval == planInterval &&
                      currentPlanName === "Elite"
                    }
                    plan="Elite"
                  />
                  <div>
                    <PlanNameAndTagContainer>
                      <PlanName plan="elite">ELITE</PlanName>
                      <PlanNameTag plan="elite">Job Management</PlanNameTag>
                    </PlanNameAndTagContainer>
                    <PlanPriceContainer>
                      <PlanPrice>
                        $
                        {planInterval === "yearly"
                          ? planPriceYearly.elite
                          : planPriceMonthly.elite}
                      </PlanPrice>
                      <PlanPriceText>per user/month</PlanPriceText>
                    </PlanPriceContainer>
                    <PlanDescription plan="elite">
                      Best for Managing Services
                    </PlanDescription>
                  </div>
                  {/* <EverythingInPrev plan="elite">
                    <TickImage src={arrow} alt="" style={{ margin: `0` }} />
                    <FeatureText style={{ marginLeft: "8px" }} fontSize="12px">
                      Everything in Standard
                    </FeatureText>
                  </EverythingInPrev> */}
                  {/* <PlusAddonDiv>Plus Add On:</PlusAddonDiv> */}
                  <PlanFeaturesContainer>
                    {planFeatures.elite.map((item, index) => (
                      <SinglePlanFeature key={index}>
                        <FeatureTickIcon
                          src={tickStandard}
                          plan="elite"
                          alt=""
                          style={{ margin: `2px 0 0 0` }}
                        />
                        <FeatureText>{item}</FeatureText>
                      </SinglePlanFeature>
                    ))}
                  </PlanFeaturesContainer>
                  <PlanSelectButton
                    plan="elite"
                    style={{ marginTop: `auto` }}
                    isCurrent={
                      currentPlanName === "Elite" &&
                      currentPlanInterval === planInterval &&
                      currentPlanStatus === "active"
                    }
                    onClick={() =>
                      confirmSelectPlan({
                        yearly: eliteYearly,
                        monthly: eliteMonthly,
                      })
                    }
                  >
                    {currentPlanName === "Elite" &&
                    currentPlanInterval === planInterval &&
                    currentPlanStatus === "trialing"
                      ? "Continue Current Plan"
                      : currentPlanName === "Free"
                      ? "Upgrade to ELITE"
                      : "Get Started"}
                  </PlanSelectButton>
                </SinglePricingCard>
                {currentSubscription?.plan?.name === "Free" ? (
                  <SinglePricingCard plan="standard-free">
                    <CurrentPlanBadge
                      isCurrent={
                        currentSubscription?.plan?.nick_name === "standard-free"
                      }
                      plan="Standard-free"
                    />
                    <div>
                      <PlanNameAndTagContainer>
                        <PlanName plan="standard_free">STANDARD FREE</PlanName>
                      </PlanNameAndTagContainer>
                      <PlanPriceContainer>
                        <PlanPrice>$0</PlanPrice>
                        <PlanPriceText>per user/month</PlanPriceText>
                      </PlanPriceContainer>
                      <PlanDescription plan="standard">
                        Suitable for small teams getting started
                      </PlanDescription>
                    </div>
                    <PlanFeaturesContainer>
                      {planFeatures.standard_free.map((item, index) => (
                        <SinglePlanFeature key={index}>
                          <FeatureTickIcon
                            src={tickStandard}
                            alt=""
                            style={{ margin: `2px 0 0 0` }}
                          />
                          <FeatureText>{item}</FeatureText>
                        </SinglePlanFeature>
                      ))}
                    </PlanFeaturesContainer>
                    {currentSubscription?.plan?.nick_name !==
                    "standard-free" ? (
                      <PlanSelectButton
                        plan="standard_free"
                        style={{ marginTop: `auto` }}
                        isCurrent={
                          currentSubscription?.plan?.nick_name ===
                          "standard-free"
                        }
                        onClick={() =>
                          confirmSelectPlan({
                            yearly: standardFree,
                            monthly: null,
                          })
                        }
                      >
                        {`Get Started`}
                      </PlanSelectButton>
                    ) : null}
                  </SinglePricingCard>
                ) : null}
                {currentSubscription?.plan?.name === "Free" ? (
                  <SinglePricingCard plan="elite-free">
                    <CurrentPlanBadge
                      isCurrent={
                        currentSubscription?.plan?.nick_name === "elite-free"
                      }
                      plan="Elite-free"
                    />
                    <div>
                      <PlanNameAndTagContainer>
                        <PlanName plan="elite_free">ELITE FREE</PlanName>
                      </PlanNameAndTagContainer>
                      <PlanPriceContainer>
                        <PlanPrice>$0</PlanPrice>
                        <PlanPriceText>per user/month</PlanPriceText>
                      </PlanPriceContainer>
                      <PlanDescription plan="elite">
                        Suitable for small teams getting started
                      </PlanDescription>
                    </div>
                    {/* <EverythingInPrev plan="free">
                      <TickImage src={arrow} alt="" style={{ margin: `0` }} />
                      <FeatureText
                        style={{ marginLeft: "8px" }}
                        fontSize="12px"
                      >
                        Everything in Standard Free
                      </FeatureText>
                    </EverythingInPrev> */}
                    <PlanFeaturesContainer>
                      {planFeatures.elite_free.map((item, index) => (
                        <SinglePlanFeature key={index}>
                          <FeatureTickIcon
                            plan="elite"
                            src={tickStandard}
                            alt=""
                            style={{ margin: `2px 0 0 0` }}
                          />
                          <FeatureText>{item}</FeatureText>
                        </SinglePlanFeature>
                      ))}
                    </PlanFeaturesContainer>
                    {currentSubscription?.plan?.nick_name !== "elite-free" ? (
                      <PlanSelectButton
                        plan="elite_free"
                        style={{ marginTop: `auto` }}
                        isCurrent={
                          currentSubscription?.plan?.nick_name === "elite-free"
                        }
                        onClick={() =>
                          confirmSelectPlan({
                            yearly: eliteFree,
                            monthly: null,
                          })
                        }
                      >
                        {`Get Started`}
                      </PlanSelectButton>
                    ) : null}
                  </SinglePricingCard>
                ) : null}
              </PricingCardContainer>
            </div>
            <SeeFullComparisonDiv>
              <SeeFullComparisonButton
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.fieldservicely.com/pricing"
              >
                See Full Pricing Comparison
              </SeeFullComparisonButton>
            </SeeFullComparisonDiv>

            <PricingAccordion />
          </>
        )}
      </PricingMainContainer>
    </div>
  );
};

export default ChangeSubscription;
